import React from 'react';
import ReactDOM from 'react-dom';
import { Rnd } from 'react-rnd';
import FontAwesome from 'react-fontawesome';

import {roundNumber, copy, trim_canvas, trim_canvas_lettersacling} from './functions.js';


class AutoscaleTextPreviewLayer extends React.Component {

    constructor(props) {
        super(props);

        
        this.state = {
            lastContent: '',
            activeColor: this.props.activeColor,
            activeFont: this.props.activeFont,
            perspectiveLayers: this.props.perspectiveLayers,
            firstInitDone: -1 
        }

        this.textWidth = -1;
        this.textHeight = -1;

        this.testCanvas = document.createElement('canvas');
        this.testCanvas.width = this.props.contentLayer.dimensions.height * 2;
        this.testCanvas.height = this.props.contentLayer.dimensions.height * 2;
        this.previewLoaded = this.previewLoaded.bind(this);
    }

    componentDidMount() {
        if (this.layerCanvasWrapper !== undefined && this.layerCanvasWrapper !== null)
        {
            let lastContent = this.state.lastContent;

            if (this.props.contentLayer.content != lastContent || 
                this.state.activeFont !== this.props.activeFont ||
                this.state.activeColor !== this.props.activeColor ||
                this.state.perspectiveLayers !== this.props.perspectiveLayers)
            {
                lastContent = this.props.contentLayer.content;
                this.updatePreviewCanvas();

                this.setState({
                    lastContent: lastContent,
                    activeFont: this.props.activeFont,
                    activeColor: this.props.activeColor,
                    perspectiveLayers: this.props.perspectiveLayers,
                });
            }
            else if (this.state.firstInitDone === -1)
            {
                this.updatePreviewCanvas();
                this.setState({
                    firstInitDone: 1,
                });
            }
        }
    }

    componentDidUpdate() {
        
        if (this.layerCanvasWrapper !== undefined && this.layerCanvasWrapper !== null)
        {
            let lastContent = this.state.lastContent;

            if (this.props.contentLayer.content != lastContent || 
                this.state.activeFont !== this.props.activeFont ||
                this.state.activeColor !== this.props.activeColor ||
                this.state.perspectiveLayers !== this.props.perspectiveLayers)
            {
                lastContent = this.props.contentLayer.content;
                this.updatePreviewCanvas();

                this.setState({
                    lastContent: lastContent,
                    activeFont: this.props.activeFont,
                    activeColor: this.props.activeColor,
                    perspectiveLayers: this.props.perspectiveLayers,
                });
            }
            else if (this.state.firstInitDone === -1)
            {
                this.updatePreviewCanvas();
                this.setState({
                    firstInitDone: 1,
                });
            }
        }
    }

    previewLoaded() {
    }

    updatePreviewCanvas() {

        if (this.layerCanvasWrapper !== undefined && this.layerCanvasWrapper !== null)
        {
            const resultCanvas = this.getTextPreviewCanvas();
            
            this.textWidth = resultCanvas.width;
            this.textHeight = resultCanvas.height;
            
            while (this.layerCanvasWrapper.hasChildNodes()) {
                this.layerCanvasWrapper.removeChild(this.layerCanvasWrapper.firstChild);
            }
            for (var charI = 0; charI < resultCanvas.words.length; charI++) {
                this.layerCanvasWrapper.appendChild(resultCanvas.words[charI].canvas);
            }

            if (this.props.activePerspective.isletterscaling == 0)
                this.layerCanvasWrapper.style.width = resultCanvas.width + 'px';
        }        
    }

    getTextPreviewCanvas()
    {
        if (this.props.activePerspective.isletterscaling == 1)
            return this.getTextPreviewCanvas_LetterScaling();
        else
            return this.getTextPreviewCanvas_BoxScaling();
    }


    getTextPreviewCanvas_LetterScaling()
    {

        const ctx = this.testCanvas.getContext('2d');
        const textCanvas = { width: 0, height: 0, words: [], content: null};

        let startY = -1;

        const char = this.props.contentLayer.content;
        let testChar = char;

        // if text ist empty or space test width with . character
        if (char == '' || char == ' ')
            testChar = '.';

        // render char to cleared canvas
        this.testCanvas.width = this.props.contentLayer.dimensions.height * ((char.length + 1) * 1.2);
        ctx.clearRect(0, 0, this.testCanvas.width, this.testCanvas.height);
        ctx.font = this.props.contentLayer.dimensions.height + "px " + this.props.activeFont.id;
        ctx.textBaseline = "hanging";
        ctx.fillStyle = this.props.activeColor.color_hex;

        // handle color per element
        if (this.props.contentLayer.color !== null && this.props.contentLayer.color !== undefined &&this.props.contentLayer.color != 'inherit')
        {
            ctx.fillStyle = this.props.contentLayer.color.color_hex;
        }

        ctx.fillText(testChar, this.props.contentLayer.dimensions.height, (this.props.contentLayer.dimensions.height / 4));

        // get trimmed canvas
        const renderChar = trim_canvas_lettersacling(this.testCanvas, testChar);
        const trimmedCanvas = renderChar.canvas;

        // if char is space add empty canvas
        if (char == ' ' || char == '')
        {
            const copy = document.createElement('canvas').getContext('2d');
            copy.canvas.width = trimmedCanvas.width * 0.1;
            copy.canvas.height = trimmedCanvas.height;

            textCanvas.width += copy.canvas.width;

            textCanvas.words.push({ canvas: copy.canvas, posY: 0, word: ' '});
        }
        else
        {
            // cound total width
            textCanvas.width += trimmedCanvas.width;

            // check startY
            if (renderChar.posY !== null && (renderChar.posY < startY || startY == -1))
                startY = renderChar.posY;

            textCanvas.words.push(renderChar);
        }

        let maxHeight = 0;
        for (var rcharI = 0; rcharI < textCanvas.words.length; rcharI++) {
            if (textCanvas.words[rcharI].word != ' ')
            {
                // calc char posY
                const charPosY = (startY - textCanvas.words[rcharI].posY) * -1;

                // check new maxHeight
                if (textCanvas.words[rcharI].canvas.height + charPosY > maxHeight)
                    maxHeight = textCanvas.words[rcharI].canvas.height + charPosY;

                // correct word Y position
                textCanvas.words[rcharI].canvas.style.marginTop = charPosY + 'px';

                textCanvas.words[rcharI].canvas.style.maxHeight = this.props.contentLayer.dimensions.height + 'px';
                textCanvas.words[rcharI].canvas.style.maxWidth = this.props.contentLayer.dimensions.width + 'px';

            }
        }

        textCanvas.height = maxHeight;
        return textCanvas;
    }


    getTextPreviewCanvas_BoxScaling()
    {
        const words = this.props.contentLayer.content.split(' ');
        const ctx = this.testCanvas.getContext('2d');
        const textCanvas = { width: 0, height: 0, words: [], content: null};
        
        let startY = -1;

        let renderWords = [];
        for (var wordI = 0; wordI < words.length; wordI++) {
            if (wordI > 0)
                renderWords.push(' ');
                
            renderWords.push(words[wordI]);
        }

        // force full word here for testing till someone complains :)
        renderWords = [this.props.contentLayer.content];

        for (var charI = 0; charI < renderWords.length; charI++) {

            const char = renderWords[charI];
            let testChar = char;

            // if text ist empty or space test width with . character
            if (char == '' || char == ' ')
                testChar = '.';

            // render char to cleared canvas
            this.testCanvas.width = this.props.contentLayer.maxDimensions.height * ((char.length + 1) * 1.2);
            ctx.clearRect(0, 0, this.testCanvas.width, this.testCanvas.height);
            ctx.font = this.props.contentLayer.maxDimensions.height + "px " + this.props.activeFont.id;
            ctx.textBaseline = "hanging";
            ctx.fillStyle = this.props.activeColor.color_hex;

            // handle color per element
            if (this.props.contentLayer.color !== null && this.props.contentLayer.color !== undefined &&this.props.contentLayer.color != 'inherit')
            {
                ctx.fillStyle = this.props.contentLayer.color.color_hex;
            }

            ctx.fillText(testChar, this.props.contentLayer.maxDimensions.height, (this.props.contentLayer.maxDimensions.height / 4));

            // get trimmed canvas
            const renderChar = trim_canvas(this.testCanvas, testChar);
            const trimmedCanvas = renderChar.canvas;

            // if char is space add empty canvas
            if (char == ' ' || char == '')
            {
                const copy = document.createElement('canvas').getContext('2d');
                copy.canvas.width = trimmedCanvas.width * 0.1;
                copy.canvas.height = trimmedCanvas.height;

                textCanvas.width += copy.canvas.width;

                textCanvas.words.push({ canvas: copy.canvas, posY: 0, word: ' '});
            }
            else
            {
                // cound total width
                textCanvas.width += trimmedCanvas.width;
 
                // check startY
                if (renderChar.posY !== null && (renderChar.posY < startY || startY == -1))
                    startY = renderChar.posY;
    
                textCanvas.words.push(renderChar);
            }
        }

        let maxHeight = 0;
        for (var rcharI = 0; rcharI < textCanvas.words.length; rcharI++) {
            if (textCanvas.words[rcharI].word != ' ')
            {
                // calc char posY
                const charPosY = (startY - textCanvas.words[rcharI].posY) * -1;

                // check new maxHeight
                if (textCanvas.words[rcharI].canvas.height + charPosY > maxHeight)
                    maxHeight = textCanvas.words[rcharI].canvas.height + charPosY;
                    
                // correct word Y position
                textCanvas.words[rcharI].canvas.style.marginTop = charPosY + 'px';
            }
        }

        textCanvas.height = maxHeight;
        return textCanvas;
    }

    isLayerVisible() {
        if (this.props.forceHidden ||
            this.props.activePerspective.id != this.props.contentLayer.perspectiveId || 
            this.props.activePerspective.varid != this.props.contentLayer.perspective_varid || 
            this.props.contentLayer.content === '' || 
            this.props.contentLayer.content === null)
            return false;

        return true;
    }

    render() {
        
        const layerStyle = {
            color: this.props.activeColor.color_hex
        };

        if (!this.isLayerVisible())
            layerStyle.display = 'none';

        let content = null;
        if (this.props.contentLayer.type = 'text')
            content = this.props.contentLayer.content;

        const dimensionsOrg = copy(this.props.contentLayer.dimensions);
        const dimensions = copy(this.props.contentLayer.dimensions);
        this.props.perspectiveLayers.forEach(function(layer) {
            if (layer.type == 'symbol' && layer.mode == 'autoscale' && layer.content !== null)
            {
                if (layer.symbolPosition == 'left')
                {
                    dimensions.posX += dimensionsOrg.height;
                    dimensions.width -= dimensionsOrg.height;
                }
                else if (layer.symbolPosition == 'right')
                {
                    dimensions.width -= dimensionsOrg.height;
                }
            }
        }, this);

        const layerFont = {
            fontFamily: this.props.activeFont.id
        };
    
        const layerPositionStyle = {
            top: dimensions.posY.toString() + 'px',
            left: dimensions.posX.toString()  + 'px'
        }; 

        const layerActiveStyle = {
            width: dimensions.width,
            height: dimensions.height,
            top: '0px',
            left: '0px'
        };
      
        let layerMoveStyle = {
            width: dimensions.width,
            height: dimensions.height,
            top: dimensions.posX,
            left: dimensions.posY,
        }

        let layerResize = {};
        if (this.props.activePerspective.isletterscaling != 1 && this.textWidth !== -1 && this.textHeight !== -1)
        {
            const scaleX = dimensions.width / this.textWidth;
            const scaleY = dimensions.height / this.textHeight;

            layerResize.WebkitTransform = 'scale(' + scaleX + ',' + scaleY + ')';
            layerResize.OTransform = 'scale(' + scaleX + ',' + scaleY + ')';
            layerResize.MsTransform = 'scale(' + scaleX + ',' + scaleY + ')';
            layerResize.MozTransform = 'scale(' + scaleX + ',' + scaleY + ')';
            layerResize.transform = 'scale(' + scaleX + ',' + scaleY + ')';
            layerResize.WebkitTransformOrigin = 'top left';
            layerResize.OTransformOrigin = 'top left';
            layerResize.MsTransformOrigin = 'top left';
            layerResize.MozTransformOrigin = 'top left';
            layerResize.transformOrigin = 'top left';
        }
        else
        {
            layerResize.width = dimensions.width;
            layerResize.height = dimensions.height;
            layerResize.textAlign = 'center';
        }

        // <canvas onLoad={this.previewLoaded} ref={r => this.layerTextCanvas = r} className="layer_text_canvas"></canvas>
        
        return (
            <div className="preview_layer autoscale_layer" style={layerStyle}>
                <div className="layer_position_wrapper" style={layerPositionStyle}>
                    <div className={"layer_resize_wrapper layer_text_resize_wrapper" + (this.props.activePerspective.isletterscaling == 1 ?  ' layer_text_letterscaling_wrapper' : '')} style={layerResize} ref={ (layerResizeWrapper) => this.layerResizeWrapper = layerResizeWrapper}>
                        <div className="layer_canvas_wrapper" ref={ (layerCanvasWrapper) => this.layerCanvasWrapper = layerCanvasWrapper}></div>
                    </div>
                </div>
            </div>
        );
    }
  }

export default AutoscaleTextPreviewLayer;




// WEBPACK FOOTER //
// ./src/AutoscaleTextPreviewLayer.js